import moment from "moment"
import { HotelContractModel } from "models"

export interface IHotelValidationErrorItem {
	field: string
	message: string
}

export interface IContractValidationErrorGroup {
	contractIndex: number
	contract?: HotelContractModel
	errors: IHotelValidationErrorItem[]
}

interface HotelValidationErrorsListProps {
	/** Errors of the hotel's own fields (type, contact number, address, rating, website). */
	hotelErrors?: IHotelValidationErrorItem[]
	contractGroups: IContractValidationErrorGroup[]
}

const formatContractDate = (date: string | number | null | undefined): string =>
	date ? moment(date).format("DD-MM-YYYY") : "—"

const getContractTitle = (group: IContractValidationErrorGroup): string => {
	const start = group.contract?.contract_start_date
	const end = group.contract?.contract_end_date
	const title = `Contract ${group.contractIndex + 1}`
	return start || end ? `${title} (${formatContractDate(start)} to ${formatContractDate(end)})` : title
}

const ErrorGroup = ({ title, errors }: { title: string; errors: IHotelValidationErrorItem[] }) => (
	<div style={{ marginBottom: "12px" }}>
		<div style={{ fontWeight: 600 }}>{title}</div>
		<ul style={{ margin: "10px 0 0", paddingLeft: "20px" }}>
			{errors.map((error, index) => (
				<li key={`${error.field}-${index}`} style={{ marginBottom: "4px" }}>
					<span style={{ fontWeight: 600 }}>{error.field}</span> — {error.message}
				</li>
			))}
		</ul>
	</div>
)

/** Lists every hotel details validation error, grouped by hotel fields and then by contract. */
const HotelValidationErrorsList = ({ hotelErrors = [], contractGroups }: HotelValidationErrorsListProps) => {

	const visibleContractGroups = contractGroups.filter((group) => group.errors.length > 0)
	if (hotelErrors.length === 0 && visibleContractGroups.length === 0) return null

	return (
		<div style={{ maxHeight: "320px", overflowY: "auto", textAlign: "left", marginTop: "16px" }}>
			{hotelErrors.length > 0 && <ErrorGroup title="Hotel Details" errors={hotelErrors} />}
			{visibleContractGroups.map((group) => (
				<ErrorGroup key={group.contractIndex} title={getContractTitle(group)} errors={group.errors} />
			))}
		</div>
	)
}

export default HotelValidationErrorsList
